import { render, staticRenderFns } from "./RevisaoCriacao.vue?vue&type=template&id=317a7be6"
import script from "./RevisaoCriacao.vue?vue&type=script&lang=js"
export * from "./RevisaoCriacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports